export default __webpack_public_path__ + "73e0534a83d19f85ab26b7b672bcf37b.png";